<template>
    <div class="row" v-if="brands != ''">
        <div class="col-12">
            <div class="brand-slider card">
                <!--<header class="card-header">
                    <h3 class="card-title"><span>برند های ویژه</span></h3>
                </header>-->
                <div class="owl-carousel">
                    <div class="item" v-for="brand in brands">
                        <router-link :title="brand.Alt != null ? brand.Alt : ''" :to="{name: 'filter' , query:{BrandCode: brand.Id , BrandName: brand.Title.replace(/\s+/g, '-')  } }">
                            <img :src="brand.LogoPath" @error="imageLoadOnError" :alt="brand.Alt != null ? brand.Alt.replace(/\s+/g, '-') : ''" :title="brand.Alt != null ? brand.Alt.replace(/\s+/g, '-') : ''">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            brands: function () {
                return this.$store.getters.readBrands;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .brand-slider {
        padding: 0;
    }
</style>